import { render, staticRenderFns } from "./customerBaseManage.vue?vue&type=template&id=1c28d7c8&scoped=true&"
import script from "./customerBaseManage.vue?vue&type=script&lang=js&"
export * from "./customerBaseManage.vue?vue&type=script&lang=js&"
import style0 from "./customerBaseManage.vue?vue&type=style&index=0&id=1c28d7c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c28d7c8",
  null
  
)

component.options.__file = "customerBaseManage.vue"
export default component.exports